function image(urlString, options = {}) {
  try {
    if (urlString.startsWith('https://images.getfullproof.com')) {
      const params = new URLSearchParams(options);
      return `${urlString}?${params.toString()}`;
    }

    if (!urlString) {
      return "https://placehold.co/300?text=No Image";
    }

    if (urlString.startsWith('/images')) {
      const url = new URL(`https://images.getfullproof.com${urlString}`);
      for (const key in options) {
        url.searchParams.set(key, options[key]);
      }
      url.searchParams.set('host', 'fp');
      return url.toString();
    }

    const url = new URL(urlString);
    url.hostname = 'images.getfullproof.com'

    for (const key in options) {
      url.searchParams.set(key, options[key]);
    }

    if (url.pathname.startsWith('/v0/b/sooperstock-app.appspot.com/o/')) {
      const [, filePath] = url.pathname.split('/v0/b/sooperstock-app.appspot.com/o/');
      url.pathname = filePath.replaceAll(/(\d{2})%(\D)/g, '$1%25$2');
      url.searchParams.set('host', 'ssa');
      return url.toString();
    }

    if (url.pathname.startsWith('/sooperstock-app.appspot.com/')) {
      const [, filePath] = url.pathname.split('sooperstock-app.appspot.com/');
      url.pathname = filePath.replaceAll(/(\d{2})%(\D)/g, '$1%25$2');
      url.searchParams.set('host', 'sss');
      return url.toString();
    }

    if (url.pathname.startsWith('/v0/b/fullproof-app.firebasestorage.app/o/')) {
      const [, filePath] = url.pathname.split('/v0/b/fullproof-app.firebasestorage.app/o/');
      url.pathname = filePath.replaceAll(/(\d{2})%(\D)/g, '$1%25$2');
      url.searchParams.set('host', 'fpa');
      return url.toString();
    }

    if (url.pathname.startsWith('/fullproof-app.firebasestorage.app/')) {
      const [, filePath] = url.pathname.split('/fullproof-app.firebasestorage.app/');
      url.pathname = filePath.replaceAll(/(\d{2})%(\D)/g, '$1%25$2');
      url.searchParams.set('host', 'fps');
      return url.toString();
    }

    console.warn(`URL not optimized with  CDN: ${urlString}`);

    return urlString;
  } catch (error) {
    console.warn(error);
    console.warn(`Invalid URL: ${urlString}`);
    return urlString;
  }
}

const cdn = {
  image,
};

export default cdn;
